import {
  EmployeeAbsenceBalanceDto,
  AbsenceBalanceHistoryDto,
  AdjustBalanceDto,
} from "../types/absence";
import { PaginatedList, PaginationParams } from "../types/pagination";
import { unwrapApiResponse } from "../utils/apiUtils";
import { api } from "./apiSlice";

export const absenceBalancesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // Get current user's balance
    getMyAbsenceBalance: builder.query<EmployeeAbsenceBalanceDto, void>({
      query: () => "absence-balances/me",
      providesTags: ["AbsenceBalances"],
      transformResponse: unwrapApiResponse,
    }),

    // Get all employee balances (Admin)
    getAllAbsenceBalances: builder.query<
      PaginatedList<EmployeeAbsenceBalanceDto>,
      PaginationParams
    >({
      query: (params) => ({
        url: "absence-balances",
        params,
      }),
      providesTags: ["AbsenceBalances"],
      transformResponse: unwrapApiResponse,
    }),

    // Get specific employee's balance
    getEmployeeAbsenceBalance: builder.query<
      EmployeeAbsenceBalanceDto,
      number
    >({
      query: (employeeId) => `absence-balances/employee/${employeeId}`,
      providesTags: (result, error, employeeId) => [
        { type: "AbsenceBalances", id: employeeId },
      ],
      transformResponse: unwrapApiResponse,
    }),

    // Get balance history for employee
    getBalanceHistory: builder.query<
      PaginatedList<AbsenceBalanceHistoryDto>,
      { employeeId: number; pagination: PaginationParams }
    >({
      query: ({ employeeId, pagination }) => ({
        url: `absence-balances/employee/${employeeId}/history`,
        params: pagination,
      }),
      providesTags: ["AbsenceBalances"],
      transformResponse: unwrapApiResponse,
    }),

    // Adjust employee balance (Admin)
    adjustEmployeeBalance: builder.mutation<
      boolean,
      { employeeId: number; dto: AdjustBalanceDto }
    >({
      query: ({ employeeId, dto }) => ({
        url: `absence-balances/employee/${employeeId}/adjust`,
        method: "POST",
        body: dto,
      }),
      invalidatesTags: ["AbsenceBalances"],
      transformResponse: unwrapApiResponse,
    }),
  }),
});

export const {
  useGetMyAbsenceBalanceQuery,
  useGetAllAbsenceBalancesQuery,
  useGetEmployeeAbsenceBalanceQuery,
  useGetBalanceHistoryQuery,
  useAdjustEmployeeBalanceMutation,
} = absenceBalancesApi;







